<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
        <div class="track-shipment update-user">
            <div class="user-info">
                <div class="inner-overflow-container" id="inner-overflow-container">
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <h2>Create Location</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="auto-complete-container">
                            <AWSAutoComplete @GetSelectedAddressData="GetSelectedAddressData($event)" @customAddressToggle="customAddressToggle($event)" :placeHolder="placeHolder" />
                        </div>
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
                                        <g id="image">
                                            <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
                                        </g>
                                    </svg>
                                        <h2>Address</h2>
                                    </div>
                                    <div id="automaticPickup" class="confirmLabelContainer">
                                        <!-- <label for="usernamePickup">Accounts</label> -->
                                        <!-- <select name="usernamePickup" v-model="selectedAccountNumber" id="usernamePickup">
                                            <option disabled selected value="">Account</option>
                                            <option v-for="(account, index) in allAccountNumbers" :key="index" :value="account.accountNo">{{account.accountNo}}</option>
                                        </select> -->
                                        <input type="text" @input="selectedAccountNumber = $event.target.value.toUpperCase()" v-model="selectedAccountNumber" placeholder="Account Number">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" v-model="serviceAddress.address.companyName" placeholder="Company Name">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" v-model="serviceAddress.address.attention" placeholder="Attention">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="address1" disabled v-model="serviceAddress.address.address1" placeholder="Address">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" v-model="serviceAddress.address.address2" placeholder="Suite/Apt.">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="city" disabled v-model="serviceAddress.address.city" placeholder="City">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <select disabled required name="state" id="state" v-model="serviceAddress.address.state">
                                            <option value="" disabled selected>State</option>
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District Of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </select>
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="zipcode" disabled v-model="serviceAddress.address.zipCode" placeholder="Zip Code">
                                    </div>

                                    <!-- <div class="confirmLabelContainer">
                                        <select name="routeCodeSelect" v-model="locationRouteCode" id="routeCodeSelect">
                                            <option disabled selected value="">Pickup Route</option>
                                            <option v-for="(route, index) in routeCodeFromGeoCode" :key="index" :value="route.routeCode">{{route.routeCode}}</option>
                                        </select>
                                    </div> -->

                                    <div v-for="routeCode in routeCodeOptions" :key="routeCode" class="confirmLabelContainer">
                                        <label for="routeOption" style="font-weight: bold; margin-top: 5px; margin-right: 5px;">{{routeCode.routeCode}}</label>
                                        <input id="routeOption" name="set-route-code" type="radio" v-model="routeCodeFromGeoCode" :value="routeCode.routeCode">
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <input type="text" id="routeCode" disabled v-model="routeCodeFromGeoCode"  placeholder="Route Code">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input class="file-input" type="file" accept=".jpg, .jpeg, .png" id="fileInput" @change="setUploadData()">
                                    </div>

                                    <div v-show="uploadFile" class="confirmLabelContainer">
                                        <img id="imgPreview" alt="">
                                    </div>
                                </div>
                            </div>

                            <div class="confirmContainerInner2">
                                <div class="confirm-svg notifications">
                                    <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                                    <h2>Notifications</h2>
                                </div>

                                <div class="confirmLabelContainer2">
                                    <div class="notificationArray" name="deliveryphone">
                                            <input type="text" v-model="serviceAddress.address.phone" placeholder="Phone">
                                    </div>
                                </div>

                                <div class="confirmLabelContainer2">
                                    <input type="text" v-model="serviceAddress.address.phoneExt" placeholder="Phone Ext.">
                                </div>

                                <div class="confirmLabelContainer2 checkbox-label-container">
                                    <label for="isCustomerLocation">Contracted Delivery</label>
                                    <input name="radioButton" v-model="isContractedDelivery" :value="true" type="radio">
                                </div>

                                <p for="automaticPickup" class="auto-pickup-label">Automatic Pickup</p>

                                 <div class="confirmLabelContainer2 checkbox-label-container">
                                    <label for="isCustomerLocation">None</label>
                                    <input name="radioButton" v-model="isNone" :value="true" type="radio">
                                </div>

                                <div class="confirmLabelContainer2 checkbox-label-container">
                                    <label for="isCustomerLocation">Daily Pickup</label>
                                    <input name="radioButton" id="isCustomerLocation" v-model="isCustomerPickup" :value="true" type="radio">
                                </div>

                                <div v-if="isCustomerPickup" class="confirmLabelContainer2">
                                    <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="pickupTime">Pickup Time</label>
                                        <input v-model="placePickupTime" id="pickupTime" type="time">
                                    </div>

                                    <!-- <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="place">Place</label>
                                        <input type="text" placeholder="Select a place" disabled v-model="selectedPlace">
                                    </div> -->

                                    <div v-if="placeData" id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="place">Place</label>
                                        <input type="text" placeholder="Select a place" disabled v-model="selectedPlace">
                                    </div>
                                </div>

                                <div class="confirmLabelContainer2 checkbox-label-container">
                                    <label for="isContractedLocation">Selected Days</label>
                                    <input name="radioButton" id="isContractedLocation" v-model="isContractedPickup" :value="true" type="radio">
                                </div>

                                <div v-if="isContractedPickup" class="confirmLabelContainer2">
                                    
                                    <div id="automaticPickup" class="confirmLabelContainer2">
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="monday">Monday</label>
                                            <input id="monday" v-model="contractedLocation.monday" value="true" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="tuesday">Tuesday</label>
                                            <input id="tuesday" v-model="contractedLocation.tuesday" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="wednesday">Wednesday</label>
                                            <input id="wednesday" v-model="contractedLocation.wednesday" value="true" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="thursday">Thursday</label>
                                            <input id="thursday" v-model="contractedLocation.thursday" value="true" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="friday">Friday</label>
                                            <input id="friday" v-model="contractedLocation.friday" value="true" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="saturday">Saturday</label>
                                            <input id="saturday" v-model="contractedLocation.saturday" value="true" type="checkbox">
                                        </div>
                                        <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                            <label for="sunday">Sunday</label>
                                            <input id="sunday" v-model="contractedLocation.sunday" value="true" type="checkbox">
                                        </div>
                                    </div>

                                    <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="pickupWindow">Pickup Start</label>
                                        <input id="pickupWindow" v-model="contractedLocation.pickupWindowStart" type="time">
                                    </div>

                                    <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="pickupWindowEnd">Pickup End</label>
                                        <input id="pickupWindowEnd" v-model="contractedLocation.pickupWindowEnd" type="time">
                                    </div>

                                    <div id="automaticPickup" class="confirmLabelContainer2 checkbox-label-container">
                                        <label for="usernamePickup">User Name</label>
                                        <select name="usernamePickup" v-model="contractedLocation.username" id="usernamePickup">
                                            <option disabled selected value="">User</option>
                                            <option v-for="(user, index) in userAccountData" :key="index" :value="user.UserName">{{user.userName}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="(AdminUser || InternalAdmin) && isCustomerPickup" class="track-shipment">
                            <place-table @checkBoxSelectID="checkBoxSelectID($event)" :locationZipCode="serviceAddress.address.zipCode" :locationLatitude="serviceAddress.address.latitude" :locationLongitude="serviceAddress.address.longitude" :key="refreshKey" :jwtToken="jwtToken" :userData="userData"/>
                        </div>

                    </div>
                <button class="update-user-button" v-if="validateCustomAddress == false" @click="CreateLocationProcess()">Create Location</button>
                <button class="update-user-button" style="background-color: #33f18a;" @click="checkAddressCorrection()" v-if="validateCustomAddress == true">Check Address</button>
            </div>
        </div>
        <div v-if="(AdminUser || InternalAdmin)" class="track-shipment update-user">
            <div class="account-input">
                <input type="text" @input="selectedAccountNumber = $event.target.value.toUpperCase()" v-model="selectedAccountNumber" placeholder="Account Number">
            </div>
            
            <account-locations :AdminUser="AdminUser" :InternalAdmin="InternalAdmin" :key="refreshKey" :jwtToken="jwtToken" :userData="accountNumberForTable" @updateSelectedAccountNo="updateAccountNo" />
        </div>
    </div>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>

<AWSAddressCorrection v-if="validateCustomAddress" @useEnteredAddress="useEnteredAddress($event)" @setCustomAddress="setCustomAddress($event)" @useCorrectedAddress="useCorrectedAddress($event)" :customAddress="userCustomAddress" :shipmentData="serviceAddress.address"/>
</template>

<script>
import { listPlaces} from '../../../graphql/queries'
import {Auth, API, Storage} from 'aws-amplify'
import AWSAutoComplete from '../../AWSLocation/AddressAutoComplete.vue';
import AWSAddressCorrection from '../../AWSLocation/AddressCorrection.vue';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import AccountLocations from '../LocationDashboard/AccountLocations.vue'
import PlaceTable from '../PlaceDashboard/PlaceTable.vue'
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue'

export default {
    data(){
        return{
            user: {},
            jwtToken: null,
            loadingUser: false,
            userData: {},
            placeHolder: "Search for address",
            validateCustomAddress: false,
            userCustomAddress: "",
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            items: `items{
                userName
                accountNo
                userEmail
            }`,
            serviceAddress: {
                address:{
                    companyName: "",
                    attention: "",
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    phone: "",
                    phoneExt: "",
                    relevance: "",
                    latitude: "",
                    longitude: "",
                    routeCode: ""
                }
            },
            isContractedPickup: false,
            isCustomerPickup: false,
            isNone: true,
            isContractedDelivery: false,
            isUser: false,
            placePickupTime: null,
            refreshKey: 0,
            uploadFile: null,
            uploadFileNoSpaces: "",
            getFileStorageURL: null,
            logoUploadSuccess: false,
            logoLocationID: "",
            placeData: null,
            selectedPlace: null,
            contractedLocation: {
                pickupWindowEnd: null,
                pickupWindowStart: null,
                username: "",
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false
            },
            userAccountData: [],
            locationRouteCode: "",
            routeCodeFromGeoCode: "",
            allAccountNumbers: [],
            selectedAccountNumber: "",
            accountNumberForTable: {
                accountNo: ""
            },
            routeCodeOptions: []
        }
    },
    components:{
        AWSAutoComplete,
        AWSAddressCorrection,
        SignedInUserInfo,
        AlertUser,
        AccountLocations,
        PlaceTable
    },
    watch:{
        'selectedAccountNumber'(){
            this.refreshKey++
            this.accountNumberForTable.accountNo = this.selectedAccountNumber;
            this.isContractedDelivery = false;
            this.isCustomerPickup = false;
            this.isContractedPickup = false;
            this.isNone = true;
            this.placePickupTime = null;
            this.selectedPlace = null;

            this.contractedLocation.pickupWindowEnd = null;
            this.contractedLocation.pickupWindowStart = null;
            this.contractedLocation.username = "";
            this.contractedLocation.monday = false;
            this.contractedLocation.tuesday = false;
            this.contractedLocation.wednesday = false;
            this.contractedLocation.thursday = false;
            this.contractedLocation.friday = false;
            this.contractedLocation.saturday = false;
            this.contractedLocation.sunday = false;
        },
        'isCustomerPickup'(newValue){
            if(newValue == true){
                this.ListPlaceGraphQL();
                this.isContractedDelivery = false;
                this.isContractedPickup = false;
                this.isNone = false;
                this.placePickupTime = null;
                this.selectedPlace = null;

                this.contractedLocation.pickupWindowEnd = null;
                this.contractedLocation.pickupWindowStart = null;
                this.contractedLocation.username = "";
                this.contractedLocation.monday = false;
                this.contractedLocation.tuesday = false;
                this.contractedLocation.wednesday = false;
                this.contractedLocation.thursday = false;
                this.contractedLocation.friday = false;
                this.contractedLocation.saturday = false;
                this.contractedLocation.sunday = false;
            }
        },
        'isContractedPickup'(newValue){
            if(newValue == true){
                this.getAccountUsers();
                this.isContractedDelivery = false;
                this.isCustomerPickup = false;
                this.isNone = false;
                this.placePickupTime = null;
                this.selectedPlace = null;

                this.contractedLocation.pickupWindowEnd = null;
                this.contractedLocation.pickupWindowStart = null;
                this.contractedLocation.username = "";
                this.contractedLocation.monday = false;
                this.contractedLocation.tuesday = false;
                this.contractedLocation.wednesday = false;
                this.contractedLocation.thursday = false;
                this.contractedLocation.friday = false;
                this.contractedLocation.saturday = false;
                this.contractedLocation.sunday = false;
            }
        },
        'isNone'(newValue){
            if(newValue == true){
                this.isContractedDelivery = false;
                this.isCustomerPickup = false;
                this.isContractedPickup = false;
                // this.isNone = false;
                this.placePickupTime = null;
                this.selectedPlace = null;

                this.contractedLocation.pickupWindowEnd = null;
                this.contractedLocation.pickupWindowStart = null;
                this.contractedLocation.username = "";
                this.contractedLocation.monday = false;
                this.contractedLocation.tuesday = false;
                this.contractedLocation.wednesday = false;
                this.contractedLocation.thursday = false;
                this.contractedLocation.friday = false;
                this.contractedLocation.saturday = false;
                this.contractedLocation.sunday = false;
            }
        },
        'isContractedDelivery'(newValue){
            if(newValue == true){
                this.isCustomerPickup = false;
                this.isContractedPickup = false;
                this.isNone = false;
                this.placePickupTime = null;
                this.selectedPlace = null;

                this.contractedLocation.pickupWindowEnd = null;
                this.contractedLocation.pickupWindowStart = null;
                this.contractedLocation.username = "";
                this.contractedLocation.monday = false;
                this.contractedLocation.tuesday = false;
                this.contractedLocation.wednesday = false;
                this.contractedLocation.thursday = false;
                this.contractedLocation.friday = false;
                this.contractedLocation.saturday = false;
                this.contractedLocation.sunday = false;
            }
        },
        'serviceAddress.address.zipCode'(){
            this.GetGeoCodeGraphQL();
        }
    },
    mounted(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();
            this.listAllAccountNumbers();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
                if (!this.AdminUser && !this.InternalAdmin) {
                    alert("Access denied to location dashboard")
                    // Redirect to the shipment page
                    this.$router.push('/ShipmentDashboard');
                }
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
    methods:{
        updateAccountNo(newAccountNo) {
            this.selectedAccountNumber = newAccountNo;
        },
        async GetGeoCodeGraphQL(){
            try {
                this.gettingUserPreferences = true;
                this.headerMessage = "Getting GeoCode Data";
                let query = `query listGeoServiceNetworks{
                        listGeoServiceNetworks(geoCode:"${this.serviceAddress.address.zipCode}"){
                            items{
                                geoCode
                                routeCode
                            }
                        }
                    }`
                let geoCodeData = await API.graphql({
                    query: query,
                    authMode: "API_KEY",
                })
                if(geoCodeData.data.listGeoServiceNetworks.items.length == 0){
                    this.toggleAlertBox = true;
                    this.alertMessage = "No route code available"
                    this.routeCodeOptions = []
                    this.routeCodeFromGeoCode = ""
                    return;
                }else{
                    this.routeCodeFromGeoCode = ""
                    this.routeCodeOptions = geoCodeData.data.listGeoServiceNetworks.items;
                    // console.log(this.locationData.routeCode)
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.gettingUserPreferences = false;
            }
        },
        checkBoxSelectID(event){
            this.selectedPlace = event;
        },
        async CreateLocationProcess(){
            this.loadingUser = true;
            if(this.uploadFile){
                if(this.uploadFile == null){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add a company logo."
                    return;
                }
                const fileNameNoSpaces = this.uploadFile.name.split(" ").join("");
                this.uploadFileNoSpaces = this.logoLocationID + fileNameNoSpaces;

                if(this.fileNameNoSpaces == ""){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add a company logo."
                    return;
                }
            }

            if(this.isContractedPickup == true){
                if(this.contractedLocation.pickupWindowEnd == null){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add pickup window end time."
                    return;
                }

                if(this.contractedLocation.pickupWindowStart == null){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add pickup window start time."
                    return;
                }

                if(this.contractedLocation.username == ""){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add a user name."
                    return;
                }
            }

            if(this.isCustomerPickup == true){
                if(this.placePickupTime == null){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Add a place pickup time."
                    return;
                }

                if(this.selectedPlace == null){
                    this.loadingUser = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Select a place."
                    return;
                }
            }

            try{
                await this.CreatAccountLocation();

                if(this.uploadFile){
                    await this.PutItemStorage();
                    await this.GetItemStorage();
                    await this.UpdateLocationForLabelImage();
                }
            }catch(e){
                console.log(e)
            }

            this.toggleAlertBox = true;
            this.alertMessage = "Created Location"
            document.getElementById('address1').disabled = true;
            document.getElementById('city').disabled = true;
            document.getElementById('state').disabled = true;
            document.getElementById('zipcode').disabled = true;
            this.validateCustomAddress = false;
            this.loadingUser = false;
        },
        setUploadData(){
            this.logoUploadSuccess = false;
            const locationLogo = document.getElementById("fileInput");
            const fileInput = locationLogo.files[0];
            this.uploadFile = fileInput;
            const imagePreview = document.getElementById('imgPreview');
            if (fileInput) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    imagePreview.src = e.target.result;
                };
                reader.readAsDataURL(fileInput);
            }
        },
        async PutItemStorage(){
            const fileNameNoSpaces = this.uploadFile.name.split(" ").join("");
            this.uploadFileNoSpaces = this.logoLocationID + fileNameNoSpaces;

            await Storage.put(this.uploadFileNoSpaces, this.uploadFile, {
                contentType: this.uploadFile.type,
            }).then(()=>{
                this.GetItemStorage();
            }).catch(()=>{
                this.toggleAlertBox = true;
                this.alertMessage = "Logo unable to upload"
                this.loadingUser = false;
            })
        },
        async GetItemStorage(){
            const imageAccessURL = await Storage.get(this.uploadFileNoSpaces);
            const targetSubstring = this.uploadFileNoSpaces;
            const splitOnPublic = imageAccessURL.split("/public/")
            if (splitOnPublic.length >= 1) {
                const trimmedUrl = splitOnPublic[0] + '/public/' + targetSubstring;
                this.getFileStorageURL = trimmedUrl;
                this.logoUploadSuccess = true;
            } else {
                this.toggleAlertBox = true;
                this.alertMessage = "Issue processing label image."
                this.logoUploadSuccess = false;
            }
        },
        async UpdateLocationForLabelImage(){
            try{
                await API.graphql({
                query:  `mutation UpdateLocation($input: UpdateLocationInput!) {
                            updateLocation(input: $input) {
                                id
                            }
                        }`,
                variables:{
                    input:{
                        id: this.logoLocationID,
                        labelImage: this.getFileStorageURL
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })

                this.logoLocationID = ""
                this.getFileStorageURL = null
                this.uploadFile = null
                this.uploadFileNoSpaces = ""
            }catch(e){
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error updating location"
                }
            }
            const imagePreview = document.getElementById('imgPreview');
            imagePreview.src = ""
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async listAllAccountNumbers(){
            let graphqlQuery = `query listAccounts{
                listAccounts{
                    items{
                        accountNo
                    }
                }
            }`
            
            try{
                let listAllAccounts = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.allAccountNumbers = listAllAccounts.data.listAccounts.items;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting accounts"
                    throw new Error("Unable to list accounts")
                }
            }
        },
        async getAccountUsers(){
            this.loadingTable = true;

            let graphqlQuery = `query listUsers{
                listUsers(filter: {accountNo: {eq: "${this.selectedAccountNumber}"}}){
                    ${this.items}
                }
            }`
            
            try{
                let usersByAccount = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.userAccountData = usersByAccount.data.listUsers.items;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting users"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async ListPlaceGraphQL(){
            try {
                let placesReturnData = await API.graphql({
                    query: listPlaces,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.placeData = placesReturnData.data.listPlaces.items;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get places"
            }
        },
        async CreatAccountLocation(){
            this.loadingUser = true;
            let phoneInput = this.serviceAddress.address.phone;
            if(!this.cleanAndValidatePhoneNumber(phoneInput)){
                this.toggleAlertBox = true;
                this.alertMessage = "Enter a valid phone number."
                this.loadingUser = false;
                throw new Error("Invalid Phone Number");
            }

            if((this.serviceAddress.address.companyName.length == 0) || (this.serviceAddress.address.address1.length == 0) || (this.serviceAddress.address.city.length == 0) || (this.serviceAddress.address.state.length == 0) || (this.serviceAddress.address.zipCode.length == 0)){
                this.toggleAlertBox = true;
                this.alertMessage = "Enter valid address information."
                this.loadingUser = false;
                throw new Error("Invalid Phone Number");
            }

            this.serviceAddress.address.routeCode = this.routeCodeFromGeoCode;

            try {
                let locationData = await API.graphql({
                    query: `mutation CreateLocation($input: CreateLocationInput!) {
                            createLocation(input: $input) {
                                id
                                accountNo
                                serviceAddress {
                                address {
                                    address1
                                    city
                                    state
                                    zipCode
                                }
                                }
                                routeCode
                            }
                        }`,
                    variables: {
                        input:{
                            accountNo: this.selectedAccountNumber,
                            serviceAddress: this.serviceAddress,
                            placeID: this.selectedPlace,
                            placePickupTime: this.placePickupTime,
                            isCustomerPickup: this.isCustomerPickup,
                            isContractedPickup: this.isContractedPickup,
                            contractedLocation: this.contractedLocation,
                            isContractedDelivery: this.isContractedDelivery,
                            routeCode: this.routeCodeFromGeoCode
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.logoLocationID = locationData.data.createLocation.id;
                this.refreshKey++
                let obj = this.serviceAddress.address;
                for (const key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        obj[key] = '';
                    }
                }
                this.selectedPlace = null;
                this.placePickupTime = null;
                this.isCustomerPickup = false;
                this.isContractedPickup = false;
                this.routeCodeOptions = []
                this.routeCodeFromGeoCode = ""
                
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create location"
                this.loadingUser = false;
                throw new Error("Unable to create location")
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        GetSelectedAddressData(selectedAddress){
            this.selectedPlace = null;
            this.serviceAddress.address.latitude = selectedAddress.latitude;
            this.serviceAddress.address.longitude = selectedAddress.longitude;
            this.serviceAddress.address.address1 = selectedAddress.address1;
            this.serviceAddress.address.address2 = selectedAddress.address2;
            this.serviceAddress.address.zipCode = selectedAddress.zipCode;
            this.serviceAddress.address.city = selectedAddress.city;
            this.serviceAddress.address.state = selectedAddress.state;
            this.serviceAddress.address.relevance = selectedAddress.relevance;
        },
        customAddressToggle(toggleCustom){
            this.selectedPlace = null;
            this.toggleAlertBox = toggleCustom;
            this.alertMessage = "Using custom addresses may incur additional costs.";

            document.getElementById('address1').disabled = false;
            document.getElementById('city').disabled = false;
            document.getElementById('state').disabled = false;
            document.getElementById('zipcode').disabled = false;
            this.validateCustomAddress = true;
        },
        checkAddressCorrection(){
            let customAddressString = this.serviceAddress.address.address1 + " " + this.serviceAddress.address.city + " " + this.serviceAddress.address.state + " " + this.serviceAddress.address.zipCode;
            //AddressCorrection Child Component is triggered when customAddress changes values
            this.userCustomAddress = customAddressString;
        },
        setCustomAddress(event){
            this.selectedPlace = null;
            this.serviceAddress.address.relevance = event.shipmentAddressData.relevance;
            this.serviceAddress.address.latitude = event.shipmentAddressData.latitude;
            this.serviceAddress.address.longitude = event.shipmentAddressData.longitude;
            this.serviceAddress.address.address1 = event.shipmentAddressData.Address1;
            this.serviceAddress.address.address2 = event.shipmentAddressData.Address2;
            this.serviceAddress.address.zipCode = event.shipmentAddressData.ZipCode;
            this.serviceAddress.address.city = event.shipmentAddressData.City;
            this.serviceAddress.address.state = event.shipmentAddressData.State;

            if(event.callInsertAddressBook == true){
                // this.CreatAccountLocation();
                this.CreateLocationProcess();
            }
        },
        useCorrectedAddress(event){
            this.selectedPlace = null;
            this.serviceAddress.address.relevance = event.shipmentDataValue.relevance;
            this.serviceAddress.address.latitude = event.shipmentDataValue.latitude;
            this.serviceAddress.address.longitude = event.shipmentDataValue.longitude;
            this.serviceAddress.address.address1 = event.shipmentDataValue.Address1;
            this.serviceAddress.address.address2 = event.shipmentDataValue.Address2;
            this.serviceAddress.address.zipCode = event.shipmentDataValue.ZipCode;
            this.serviceAddress.address.city = event.shipmentDataValue.City;
            this.serviceAddress.address.state = event.shipmentDataValue.State;

            if(event.callInsertAddressBook == true){
                // this.CreatAccountLocation();
                this.CreateLocationProcess();
            }
        },
        useEnteredAddress(event){
            if(event.callInsertAddressBook == true){
                // this.CreatAccountLocation();
                this.CreateLocationProcess();
            }
        },
        cleanAndValidatePhoneNumber(inputPhoneNumber) {
            // Remove all non-digit characters from the input phone number
            const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');

            // Check if the cleaned phone number is exactly 10 digits
            if(cleanedPhoneNumber.length == 0){
                return true;
            }else if(cleanedPhoneNumber.length !== 10) {
                return false; // Invalid phone number
            }else{
                this.serviceAddress.address.phone = cleanedPhoneNumber;
                return true;
            }
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #000;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

input[type="time"] {
    padding: 2px;
}

input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #c4c4c4;
    border-radius: 999px;
    padding: 0;

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="radio"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="radio"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    background-color: #33f18a;
    border-radius: 999px;
}

input[type="radio"]:checked::before {
    transform: scale(1);
}


input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    padding: 0;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}


input[type=file]::file-selector-button {
    border: none;
    padding: 5px;
    border-radius: 15px;
    background-color: #32ccfe;
    transition: 1s;
    color: #fff;
    cursor: pointer;
}

input[type=file]::file-selector-button:hover {
    background-color: #2dbbeb;
    transition: 1s;
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 150px;
    margin-top: 5px;
    border-radius: 5px;
}

.auto-pickup-label{
    font-weight: bold;
    margin-top: 10px !important;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.checkbox-label-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;
}

.checkbox-label-container input{
    margin-left: auto;
}

.checkbox-label-container select{
    margin-left: auto;
}

.file-input{
    width: 80%;
}

html{
    background-color: #f3f3f3;
}

.main-container{
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container{
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
}

.header-track-inner svg{
    height: 22px;
    margin: 0;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    width: fit-content;
    height: fit-content;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.account-input{
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 5px;
}

.update-user{
    flex-basis: 60%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 10px;
}

.auto-complete-container{
    margin-top: 5px !important;
    width: 90%;
    margin-left: 10px;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

@media only screen and (max-width: 1300px) {
    .inner-container{
        width: 85%;
    }
}

@media only screen and (max-width: 1000px) {
    .data-container-main, .inner-track-shipment-container{
        flex-wrap: wrap;
    }

    .track-shipment{
        flex-basis: 70%;
    }

    .data-container{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container{
        width: 95%;
    }

    .data-container{
        flex-basis: 80%;
    }

    .track-shipment{
        flex-basis: 80%;
    }

    .confirmContainerInner{
        flex-wrap: wrap;
    }

    .notifications{
        margin-top: 5px;
    }
}
</style>